module.exports = __webpack_public_path__ + "static/Susanne_namnbild-436cce5b5e7cb2e039df43b17d4afd4f.svg";